// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"467":"58c63625","880":"d5db812a"}[chunkId] + ".chunk.js";
};